import { type PaymentMethodLanguage, type PaymentMethodTranslations, type AddCardModalTranslations } from './types';

export const translations: Record<PaymentMethodLanguage, PaymentMethodTranslations> = {
  ko: {
    title: '결제 수단',
    addCard: '새 카드 등록',
    mainCard: '주카드',
    setAsMain: '주카드로 설정',
    deleteCard: '카드 삭제',
    cardHolder: '카드 소유자',
    expiryDate: '만료일',
    noCards: '등록된 카드가 없습니다',
    addFirstCard: '첫 카드를 등록해주세요',
    confirmDelete: '이 카드를 삭제하시겠습니까?',
    cancel: '취소',
    delete: '삭제',
    loading: '로딩 중...',
    retry: '다시 시도'
  },
  es: {
    title: 'Método de pago',
    addCard: 'Registrar nueva tarjeta',
    mainCard: 'Tarjeta principal',
    setAsMain: 'Establecer como principal',
    deleteCard: 'Eliminar tarjeta',
    cardHolder: 'Titular de la tarjeta',
    expiryDate: 'Fecha de vencimiento',
    noCards: 'No hay tarjetas registradas',
    addFirstCard: 'Registre su primera tarjeta',
    confirmDelete: '¿Desea eliminar esta tarjeta?',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    loading: 'Cargando...',
    retry: 'Reintentar'
  },
  en: {
    title: 'Payment method',
    addCard: 'Register new card',
    mainCard: 'Main card',
    setAsMain: 'Set as main',
    deleteCard: 'Delete card',
    cardHolder: 'Card holder',
    expiryDate: 'Expiry date',
    noCards: 'No cards registered',
    addFirstCard: 'Register your first card',
    confirmDelete: 'Do you want to delete this card?',
    cancel: 'Cancel',
    delete: 'Delete',
    loading: 'Loading...',
    retry: 'Retry'
  }
};

export const addCardModalTranslations: Record<PaymentMethodLanguage, AddCardModalTranslations> = {
  ko: {
    title: '카드 등록',
    subtitle: '안전한 결제를 위해 카드를 등록하세요',
    loading: '로딩 중...',
    creatingCheckout: '결제 준비 중...',
    confirmingRegistration: '카드 등록 확인 중...',
    successTitle: '카드 등록 완료',
    successMessage: '카드가 성공적으로 등록되었습니다',
    errorTitle: '오류 발생',
    errorMessage: '카드 등록에 실패했습니다',
    retry: '다시 시도',
    done: '완료',
    cancel: '취소',
    nicknameLabel: '카드 별명 (선택)',
    nicknamePlaceholder: '예: 내 카드',
    skipNickname: '건너뛰기',
    saveWithNickname: '저장',
    cardNumberLabel: '카드 번호',
    expiryMonthLabel: '월',
    expiryYearLabel: '연도',
    cvvLabel: 'CVV',
    holderLabel: '카드 소유자',
    invalidCard: '유효하지 않은 카드 번호입니다.',
    invalidExpiry: '유효하지 않은 만료일입니다.',
    invalidCvv: '유효하지 않은 CVV입니다.',
    invalidHolder: '카드 소유자 이름을 입력해 주세요.'
  },
  es: {
    title: 'Registrar tarjeta',
    subtitle: 'Registre su tarjeta para pagos seguros',
    loading: 'Cargando...',
    creatingCheckout: 'Preparando pago...',
    confirmingRegistration: 'Confirmando registro...',
    successTitle: 'Registro exitoso',
    successMessage: 'Su tarjeta ha sido registrada',
    errorTitle: 'Error',
    errorMessage: 'Error al registrar tarjeta',
    retry: 'Reintentar',
    done: 'Listo',
    cancel: 'Cancelar',
    nicknameLabel: 'Apodo de tarjeta (opcional)',
    nicknamePlaceholder: 'Ej: Mi tarjeta',
    skipNickname: 'Omitir',
    saveWithNickname: 'Guardar',
    cardNumberLabel: 'Número de tarjeta',
    expiryMonthLabel: 'Mes',
    expiryYearLabel: 'Año',
    cvvLabel: 'CVV',
    holderLabel: 'Titular',
    invalidCard: 'Número de tarjeta inválido',
    invalidExpiry: 'Fecha de vencimiento inválida',
    invalidCvv: 'CVV inválido',
    invalidHolder: 'Ingresa el titular de la tarjeta'
  },
  en: {
    title: 'Register Card',
    subtitle: 'Register your card for secure payments',
    loading: 'Loading...',
    creatingCheckout: 'Preparing payment...',
    confirmingRegistration: 'Confirming registration...',
    successTitle: 'Registration Complete',
    successMessage: 'Your card has been registered successfully',
    errorTitle: 'Error',
    errorMessage: 'Failed to register card',
    retry: 'Retry',
    done: 'Done',
    cancel: 'Cancel',
    nicknameLabel: 'Card nickname (optional)',
    nicknamePlaceholder: 'e.g., My Card',
    skipNickname: 'Skip',
    saveWithNickname: 'Save',
    cardNumberLabel: 'Card number',
    expiryMonthLabel: 'Month',
    expiryYearLabel: 'Year',
    cvvLabel: 'CVV',
    holderLabel: 'Cardholder name',
    invalidCard: 'Invalid card number',
    invalidExpiry: 'Invalid expiration date',
    invalidCvv: 'Invalid CVV',
    invalidHolder: 'Enter the cardholder name'
  }
};

export const mockCards = [
  {
    id: '1',
    type: 'visa' as const,
    lastFour: '1234',
    holder: 'John Doe',
    expiry: '12/25',
    isDefault: true
  },
  {
    id: '2',
    type: 'mastercard' as const,
    lastFour: '5678',
    holder: 'Jane Smith',
    expiry: '08/26',
    isDefault: false
  }
];
